import { render, staticRenderFns } from "./OfficeInfo.vue?vue&type=template&id=edc9a58a&scoped=true&"
import script from "./OfficeInfo.vue?vue&type=script&lang=js&"
export * from "./OfficeInfo.vue?vue&type=script&lang=js&"
import style0 from "./OfficeInfo.vue?vue&type=style&index=0&id=edc9a58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc9a58a",
  null
  
)

export default component.exports